import { render, staticRenderFns } from "./pLabel.vue?vue&type=template&id=3c197403&"
import script from "./pLabel.vue?vue&type=script&async=true&lang=js&"
export * from "./pLabel.vue?vue&type=script&async=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports